import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import { useSelector } from 'react-redux';
import { buttons } from '../../utils/footer';
import { ADVERTISE_ON_RON_ORP_META } from '../../utils/meta';

const PageContainer = dynamic(() => import('../components/PageContainer/PageContainer'));
const SquareButton = dynamic(() => import('../components/FooterPages/AdvertiseOnRon/SquareButton'));
const CustomersOfRon = dynamic(() => import('../components/FooterPages/CustomersOfRon'));

export async function getServerSideProps({query}) {
  const { city } = query;
  return {
    props: {
      metaData: ADVERTISE_ON_RON_ORP_META(city),
    },
  };
}

const AdvertiseOnRonOrp = () => {
  const router = useRouter();
  const { city } = router.query;
const lang = useSelector(({ common }) => common?.language);

  return (
    <PageContainer>
      <div className=' px-[75px]'>
        <h1 className='mt-8 text-center text-[36px] font-semibold uppercase md:mt-[64px] md:text-[48px]'>
          {lang?.market?.advertise_on_ron_orp}
        </h1>
        <p className='mx-auto mb-8 max-w-[973px] text-center text-[16px] text-[#9e9e9e] md:mb-[77px] md:text-[22px]'>
          {lang?.common?.advertise_on_ron_orp_page_desc}
        </p>
      </div>
      <div className='mx-auto flex  max-w-[973px]  flex-wrap justify-center gap-8 md:mb-[104px]'>
        {buttons(city, lang).map((item, index) => {
          return <SquareButton key={index} data={item} />;
        })}
      </div>

      <CustomersOfRon />
    </PageContainer>
  );
};

export default AdvertiseOnRonOrp;
